var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconConsultationActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4998 11.0352C18.8329 11.1927 19.1523 11.3759 19.4538 11.5838C20.7165 12.4543 21.5887 13.7048 21.8822 15.1142C22.1543 16.4201 21.9076 17.7593 21.1996 18.9144L21.9618 21.1363C21.9825 21.1933 21.9952 21.2535 21.9987 21.3153C22.0033 21.3949 21.9927 21.4734 21.9685 21.5473C21.9395 21.637 21.8916 21.7169 21.8301 21.7836C21.7688 21.8505 21.6925 21.9057 21.6041 21.9439C21.5312 21.9755 21.4522 21.9946 21.3704 21.999C21.3068 22.0025 21.2438 21.997 21.1832 21.9834L18.281 21.3834C16.9222 21.9704 15.3745 22.1347 13.8947 21.8499C12.3372 21.5501 10.9418 20.7689 9.97796 19.6327C9.36623 18.9115 8.95581 18.0789 8.77371 17.202",
    stroke: "#00AA4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.78699 16.9989C2.86649 17.0034 2.94519 16.9964 3.02094 16.9788L6.64881 16.2074C8.34733 16.9622 10.2819 17.1734 12.1317 16.8072C14.0787 16.4217 15.8229 15.4173 17.0277 13.9564C18.2351 12.4924 18.8151 10.6711 18.6349 8.83242C18.4548 6.99511 17.5316 5.29997 16.069 4.05308C14.6084 2.80802 12.7046 2.08823 10.7148 2.0076C8.72508 1.92697 6.75938 2.48981 5.18273 3.60775C3.60431 4.72695 2.51411 6.3348 2.14713 8.14685C1.80709 9.82591 2.11545 11.5477 3.00048 13.0329L2.04774 15.8896C2.02182 15.9629 2.006 16.0404 2.00158 16.1198C1.99576 16.2221 2.00909 16.3231 2.03925 16.4181C2.07561 16.5335 2.13547 16.6362 2.21228 16.722C2.28893 16.8079 2.38427 16.8789 2.49482 16.928C2.58589 16.9686 2.68471 16.9932 2.78699 16.9989Z",
    stroke: "#00AA4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3337 8.66663C10.7939 8.66663 11.167 9.03787 11.167 9.49581V9.50411C11.167 9.96205 10.7939 10.3333 10.3337 10.3333C9.87342 10.3333 9.50033 9.96205 9.50033 9.50411V9.49581C9.50033 9.03787 9.87342 8.66663 10.3337 8.66663Z",
    fill: "#00AA4E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00033 8.66663C7.46056 8.66663 7.83366 9.03787 7.83366 9.49581V9.50411C7.83366 9.96205 7.46056 10.3333 7.00033 10.3333C6.54009 10.3333 6.16699 9.96205 6.16699 9.50411V9.49581C6.16699 9.03787 6.54009 8.66663 7.00033 8.66663Z",
    fill: "#00AA4E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.667 8.66663C14.1272 8.66663 14.5003 9.03787 14.5003 9.49581V9.50411C14.5003 9.96205 14.1272 10.3333 13.667 10.3333C13.2068 10.3333 12.8337 9.96205 12.8337 9.50411V9.49581C12.8337 9.03787 13.2068 8.66663 13.667 8.66663Z",
    fill: "#00AA4E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConsultationActive);
export default __webpack_public_path__ + "static/media/icon_consultation_active.1d80356e7d512c3a898cd51cc8af5810.svg";
export { ForwardRef as ReactComponent };